import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * [state, copy(text)]: state is 'copied' or 'failed' for a moment after copying, else null
 */
export default function useCopy(resetAfter = 1500) {
  const [state, setState] = useState(null);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState(null), resetAfter);
  }, [resetAfter]);

  return [state, copy];
}
